module.exports = __webpack_public_path__ + "static/media/flutter.b003eb47.webp";